<template lang="pug">
.work-order-jobs.mt-30
  // eslint-disable vue/no-mutating-props
  .d-flex.align-items-center.justify-content-between.my-0
    h4.my-0.inline-block Jobs

    .table-actions-wrapper.my-20
      .table-actions-right
        AppButton#new-job-btn(
          type="primary"
          @click="$emit('new-job')"
        ) Add job

  .job-filters.d-flex.align-items-end.justify-content-between.flex-wrap
    AppDateRangePicker.date-filter.max-w-30rem.mr-30(
      :end-date="stopDate"
      :start-date="initDate"
      compute-monthly-exclusion
      compute-biweekly-exclusion
      @change="onDateRangeChange"
      @clear="onDateRangeClear"
    )
    .d-flex.flex-column.status-filter
      label.control-label
        | Status
      AppSelect(
        v-model="jobVirtualStateFilter"
        :options="jobVirtualStatesOptions"
        :async-delay="5"
      )

  WorkOrdersJobsTable(
    :all-jobs="allJobs"
    @show-job="onShowJob"
    @edit-job="onEditJob"
    @delete-job="onDeleteJob"
    @complete-job="onCompleteJob"
    @reopen-job="onReopenJob"
    @page-changed="onPageChanged"
  )
</template>

<script>
import { JOB_VIRTUAL_STATES } from '~/app_constants';
import WorkOrdersJobsTable from '~/components/work_orders/details_page/WorkOrdersJobsTable.vue';

export default {
  name: 'WorkOrdersJobsSection',
  components: {
    WorkOrdersJobsTable,
  },
  props: {
    allJobs: {
      type: Array,
      default: () => [],
    },
    endDate: {
      type: String,
      default: () => undefined,
    },
    startDate: {
      type: String,
      default: () => undefined,
    },
    jobsQueryStatus: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    jobVirtualStatesOptions: Object.freeze([{ id: 'all', text: 'All statuses' }, ...JOB_VIRTUAL_STATES]),
  }),
  computed: {
    jobVirtualStateFilter: {
      get() {
        return this.jobsQueryStatus || 'all';
      },
      set(value) {
        const finalValue = value === 'all' ? null : value;

        // Reset the page so we don't get into weird states
        this.$emit('status-changed', finalValue);
      },
    },
    stopDate() {
      // Need to return `undefined` otherwise the component will render `NaN`
      return this.endDate ? moment(this.endDate) : undefined;
    },
    initDate() {
      // Need to return `undefined` otherwise the component will render `NaN`
      return this.startDate ? moment(this.startDate) : undefined;
    },
  },
  methods: {
    onPageChanged(page) {
      this.$emit('page-changed', page);
    },
    onDateRangeChange(dateRange) {
      this.$emit('date-range-change', dateRange);
    },
    onDateRangeClear() {
      // Avoid adding new handler to the parent and reuse the same one, but
      // send `undefined` values in order to simplify things.
      this.$emit('date-range-change', { start: undefined, end: undefined });
    },
    onShowJob(jobId) {
      this.$emit('show-job', jobId);
    },
    onEditJob(jobId) {
      this.$emit('edit-job', jobId);
    },
    onDeleteJob(job) {
      this.$emit('delete-job', job);
    },
    onCompleteJob(job) {
      this.$emit('complete-job', job);
    },
    onReopenJob(job) {
      this.$emit('reopen-job', job);
    },
  },
};
</script>
